<div class="relative overflow-x-hidden">
  <div class="w-full row-end-center gap-2">
    <p-button [label]="'Save' | translateWF: 'Save'" (onClick)="saveQuotation()" />
    <p-button [label]="'Close' | translateWF: 'Close'" variant="outlined" (onClick)="closeQuote()" />
  </div>
  <form [formGroup]="quoteFormGroup">
    <div class="page__title under__line">
      <h2>{{ 'Quote Details' }}</h2>
    </div>
    <div class="grid-2 gap-[1rem]">
      <div class="span-1">
        <div class="form-box">
          <label>Expiration of quote </label>
          <p-datepicker
            [iconDisplay]="'input'"
            formControlName="expirationDate"
            [showIcon]="true"
            inputId="icondisplay"
            class="w-full"
            fluid
            [ngClass]="{
              'ng-invalid ng-dirty': quoteFormGroup.controls['expirationDate'].invalid && quoteFormGroup.controls['expirationDate'].touched,
            }"
          />
        </div>
      </div>
      <div class="span-1">
        <div class="form-box">
          <label>Associated Requisition</label>
          <input pInputText [value]="requisition().number" class="w-full" [disabled]="true" />
        </div>
      </div>
      <div class="span-1">
        <div class="form-box">
          <label>Issue Date</label>
          <p-datepicker
            [iconDisplay]="'input'"
            formControlName="issuedDate"
            [showIcon]="true"
            inputId="icondisplay"
            class="w-full"
            fluid
            [ngClass]="{
              'ng-invalid ng-dirty': quoteFormGroup.controls['issuedDate'].invalid && quoteFormGroup.controls['issuedDate'].touched,
            }"
          />
        </div>
      </div>
      <div class="span-1">
        <div class="form-box">
          <label>Provider Number</label>
          <input
            pInputText
            class="w-full"
            formControlName="providerReferenceNumber"
            [ngClass]="{
              'ng-invalid ng-dirty': quoteFormGroup.controls['providerReferenceNumber'].invalid && quoteFormGroup.controls['providerReferenceNumber'].touched,
            }"
          />
        </div>
      </div>
    </div>
    <div class="page__title under__line mt-[2rem]">
      <h2>{{ 'Provider Details' }}</h2>
    </div>
    <div class="grid-3 gap-[1rem]">
      <div class="span-3">
        <div class="form-box">
          <label>Provider</label>
          <p-autocomplete
            fluid
            class="w-full mb-[0.5rem]"
            formControlName="providerReference"
            [dropdown]="true"
            [suggestions]="providersToDisplay"
            optionLabel="name"
            optionValue="id"
            (completeMethod)="searchProvider($event)"
          >
          </p-autocomplete>
          <div class="row-start-center mb-[1rem]">
            <p-checkbox [formControl]="unsavedProvider" [binary]="true" />
            <span class="ml-2" style="color: #0369a1">Provider does not exist in the system</span>
          </div>
          <!-- unregister provider -->
          @if (unsavedProvider.value) {
            <div class="form-box w-full">
              <label>Provider Name</label>
              <input pInputText class="w-full" formControlName="unsavedProviderName" />
            </div>
          }
        </div>
      </div>
      <div class="span-1">
        <div class="form-box">
          <label for="">Currency</label>
          <p-select
            [options]="currencyOptions()"
            styleClass="w-full"
            formControlName="currency"
            [ngClass]="{
              'ng-invalid ng-dirty': quoteFormGroup.controls['currency'].invalid && quoteFormGroup.controls['currency'].touched,
            }"
          />
        </div>
      </div>
      <div class="span-1">
        <div class="form-box">
          <label for="">Exchange Rate</label>
          <div class="row-sm-start-center">
            <p-inputnumber
              formControlName="exchangeRateToUSD"
              [minFractionDigits]="2"
              [maxFractionDigits]="25"
              styleClass="w-full"
              [ngClass]="{
                'ng-invalid ng-dirty': quoteFormGroup.controls['exchangeRateToUSD'].invalid && quoteFormGroup.controls['exchangeRateToUSD'].touched,
              }"
            />
            <p-button label="Reload" (onClick)="fetchCurrencyExchangeRateToUSD()"></p-button>
          </div>
        </div>
      </div>
      <div class="span-1">
        <div class="form-box">
          <label for="">Payment Method</label>
          <csl-dropdown-master-data
            formControlName="paymentMethod"
            class="w-full required"
            categoryCode="PaymentMode"
            (onDelete)="handleDelete($event)"
            (emitMessagesApi)="showMessagesApi($event)"
            [allowCreate]="false"
            [ngClass]="{
              'ng-invalid ng-dirty': quoteFormGroup.controls['paymentMethod'].invalid && quoteFormGroup.controls['paymentMethod'].touched,
            }"
          />
        </div>
      </div>
    </div>

    <!-- !product set prices  -->
    <div class="page__title under__line mt-[2rem]">
      <h2>{{ 'Product Details' }}</h2>
    </div>

    <!-- New feature table with all items for add  -->
    <!-- <p-table [value]="requisition().entries" class="w-full"> -->
    <p-table [value]="itemsFormArray.controls" class="w-full">
      <ng-template pTemplate="header">
        <tr>
          <th>Item</th>
          <th>Quantity</th>
          <th>Brand</th>
          <th>Unit Price</th>
          <th>Total Price</th>
          <th>Media</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowGroup let-rowIndex="rowIndex">
        <tr [formGroup]="rowGroup">
          <td>
            <b>{{ rowGroup.value.itemCode }}</b> - {{ localeHelperService.getLocalizedValue(rowGroup.value.itemDisplayName) }}
          </td>
          <td>
            <p-inputgroup>
              <p-inputNumber formControlName="quantity" />
              {{ getUnitOfMeasure(rowGroup.get('uom')?.value) }}
            </p-inputgroup>
          </td>
          <td><input type="text" pInputText formControlName="brand" /></td>
          <td>
            <div class="col-sm pt-8">
              <p-inputNumber formControlName="unitPrice" [minFractionDigits]="2" [maxFractionDigits]="4" />
              <div class="row-start-center gap-1">
                <label>Exempt</label>
                <p-toggleSwitch formControlName="isTaxExempt" />
              </div>
            </div>
          </td>
          <td>
            <div class="col-sm">
              <span>
                {{ calculateItemTotalPriceFromForm(rowGroup) | currency: getSelectedCurrency() : 'symbol' : '1.2-2' }}
              </span>
              @if (isLocalCurrency) {
                <span class="text-sm text-gray-500">
                  {{ getValueOnUSD(calculateItemTotalPriceFromForm(rowGroup)) | currency: 'USD' : 'symbol' : '1.2-2' }}
                </span>
              }
            </div>
          </td>

          @if (rowGroup.get('filesApi')?.value.length > 0) {
            <td>
              <img
                [src]="rowGroup.get('filesApi')?.value[0].presignedUrl"
                alt="Product Image"
                class="w-20 h-20 cursor-zoom-in"
                (click)="onFileClick(rowGroup.get('filesApi')?.value[0])"
              />
            </td>
          } @else {
            <td>
              <input type="file" class="hidden" (change)="handleFilesInput($event, rowIndex)" accept="image/jpeg,image/jpg,image/png" #fileInput />

              <p-button label="Add File" severity="secondary" size="small" (onClick)="fileInput.click()" />
            </td>
          }
        </tr>
      </ng-template>
    </p-table>

    <!-- !cost and taxes -->
    <div class="page__title under__line mt-[2rem]">
      <h2>{{ 'Costs and taxes' }}</h2>
    </div>
    <form [formGroup]="taxesFormGroup">
      <div class="grid-2 gap-[1rem]">
        <div class="span-2">
          <div class="form-box">
            <label>Subtotal</label>
            <div class="col">
              <span>{{ subtotal | currency: getSelectedCurrency() : 'symbol' : '1.2-2' }}</span>
              @if (isLocalCurrency) {
                <span class="text-sm text-gray-500">{{ getValueOnUSD(subtotal) | currency: 'USD' : 'symbol' : '1.2-2' }}</span>
              }
            </div>
          </div>
        </div>
        <div class="span-1">
          <div class="form-box">
            <label>ISV 15%</label>
            <div class="col">
              <span>{{ taxAmount | currency: getSelectedCurrency() : 'symbol' : '1.2-2' }}</span>
              @if (isLocalCurrency) {
                <span class="text-sm text-gray-500">{{ getValueOnUSD(taxAmount) | currency: 'USD' : 'symbol' : '1.2-2' }}</span>
              }
            </div>
          </div>
        </div>
        <div class="span-1">
          <div class="form-box">
            <label>Total</label>
            <div class="col">
              <span>{{ total | currency: getSelectedCurrency() : 'symbol' : '1.2-2' }}</span>
              @if (isLocalCurrency) {
                <span class="text-sm text-gray-500">{{ getValueOnUSD(total) | currency: 'USD' : 'symbol' : '1.2-2' }}</span>
              }
            </div>
          </div>
        </div>
      </div>
    </form>
    <div class="page__title under__line mt-[2rem]">
      <h2>{{ 'Aditional Information' }}</h2>
    </div>
    <div class="grid-1 gap-[1rem]">
      <div class="span-1">
        <div class="form-box">
          <label>Add Note</label>
          <textarea rows="5" cols="30" pTextarea class="w-full"></textarea>
        </div>
      </div>
    </div>
  </form>
</div>

<loading-overlay [isLoading]="isLoading > 0" />
